import React, {useContext} from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import {useNavigate} from 'react-router';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faXmark, faPencilAlt, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import { MadricContext } from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @return {JSX}
 */
function TodoList(props) {
  const navigate = useNavigate();
  const {setWhatToShow, setActiveLink} = useContext(MadricContext);
  const todolist = props.todolist;
  const returnTo = 'global';
   
  return (
    <div className="checkin-container">
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>TODOLIST</span> {props.formatDate(props.todolist.date)}
          <button style={{marginLeft:"5px"}} className="checkin-pagination-button float-end" onClick={() => {setWhatToShow('1'); navigate('/chantier/' + props.todolist.place_id); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faArrowRight} /></button>
          <button className="checkin-pagination-button float-end" onClick={() => {navigate('/UpdateTodolist', {state: {todolist, returnTo}}); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
        <ListGroup.Item className="checkin-list-item" style={{fontWeight:"bold", fontSize:"18px"}}>
           {props.todolist.user_name}
          </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
            Projet: {props.todolist.place_name}
          </ListGroup.Item>

          <ListGroup.Item className="checkin-list-item">
            Description: {props.todolist.description}
          </ListGroup.Item>
          <ListGroup.Item
            className="checkin-list-item"
            style={{
              backgroundColor:
              props.todolist.complete === 1 ? 'green' : 'red',
            }}>
            Complété: {props.todolist.complete === 1 ? <FontAwesomeIcon icon={faCheck} style={{fontSize: '25px'}} /> : <FontAwesomeIcon icon={faXmark} style={{fontSize: '25px'}} />}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Date complété: {props.todolist.date_complete}
          </ListGroup.Item>


          <ListGroup.Item className="checkin-list-item">
            Employé complété: {props.todolist.user_name_complete}
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </div>
  );
}

export default TodoList;